{
  "language": "Idioma",
  "confirm_default_title": "¿Estás seguro?",
  "actions": {
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "saving": "Guardando…",
    "saved": "Guardado ✓",
    "delete": "Eliminar",
    "deleting": "Eliminando…",
    "edit": "Editar",
    "close": "Cerrar",
    "back": "Volver",
    "continue": "Continuar",
    "retry": "Reintentar",
    "ok": "OK, entiendo",
    "create": "Crear",
    "invite": "Invitar",
    "search": "Buscar",
    "open": "Abrir",
    "show": "Mostrar",
    "hide": "Ocultar"
  },
  "states": {
    "empty": "No hay nada por aquí todavía.",
    "no_results": "Sin resultados.",
    "loading": "Cargando…",
    "error": "Algo salió mal."
  },
  "offline": "Sin conexión — algunas acciones están deshabilitadas",
  "toast_region": "Notificaciones",
  "toast_close": "Cerrar notificación",
  "cookies": {
    "message": "Usamos cookies y herramientas como PostHog (analítica anónima) y Sentry (reportes de errores) para mejorar Tworks.",
    "policy_link": "Ver política de privacidad",
    "accept": "OK, entiendo",
    "close_label": "Cerrar aviso de cookies",
    "region_label": "Aviso de cookies"
  },
  "google_play": {
    "cta": "Descárgala en Google Play"
  },
  "pwa": {
    "title": "Instala Tworks",
    "android_title": "Tworks para Android",
    "android_description": "Ya está en Google Play: notificaciones push y grabación de reuniones desde tu teléfono.",
    "description": "Acceso rápido desde tu pantalla de inicio. Funciona offline lo básico.",
    "install": "Instalar",
    "installing": "Instalando…",
    "later": "Ahora no",
    "ios_description": "En iPhone y iPad se instala desde el menú de compartir de Safari:",
    "ios_step_share": "Toca el botón Compartir",
    "ios_step_add": "Elige «Añadir a pantalla de inicio»",
    "got_it": "Entendido"
  },
  "teams": {
    "config": {
      "title": "Tworks",
      "body": "Tworks se mostrará en esta pestaña. Pulsa «Guardar» para añadirlo al canal."
    }
  },
  "common": {
    "stop_timer": "Detener temporizador"
  },
  "share": {
    "copied": "Enlace copiado al portapapeles",
    "failed": "No se pudo copiar el enlace"
  }
}
